module.exports = __webpack_public_path__ + "img/notify3.7168c517.png";